export default {
  year: [],
  adm0_a3: [],
  shape: [],
  weekday: [],
};
